import { WellnessWheelIconProps } from "../types";

export default function MentalHealthCategoryIcon({
  iconColorFill,
  arcColorFill,
}: WellnessWheelIconProps) {
  return (
    <g
      transform-origin={`60.434 59.615`}
      style={{
        animation: "scaleIn 0.2s ease-out 2.05s forwards",
        transformOrigin: `60.434px 59.615px`,
        opacity: 0,
      }}
    >
      {/* Top-left cutout for Brain icon */}
      <path
        d="M83.6396 77.9385C86.0747 74.8505 87.8633 71.3039 88.8988 67.51C89.9343 63.7162 90.1955 59.7527 89.6669 55.8558C89.1382 51.9589 87.8306 48.2082 85.8219 44.8273C83.8131 41.4464 81.1444 38.5044 77.9746 36.1767C74.8049 33.849 71.199 32.1831 67.3719 31.2784C63.5448 30.3736 59.5747 30.2485 55.6982 30.9105C51.8217 31.5725 48.1181 33.008 44.8081 35.1316C41.4981 37.2551 38.6494 40.0232 36.4318 43.2709L60.6306 59.7945L83.6396 77.9385Z"
        fill={"white"}
        stroke="white"
        strokeWidth="2"
      />

      {/* Brain/Person icon circle - Top left (Mental Health) */}
      <rect
        x="36.8655"
        y="36.0459"
        width="47.1383"
        height="47.1383"
        rx="23.5691"
        fill={iconColorFill}
      />
      <rect
        x="36.8655"
        y="36.0459"
        width="47.1383"
        height="47.1383"
        rx="23.5691"
        stroke={arcColorFill}
        strokeWidth="3.82202"
      />

      {/* Brain/Person icon */}
      <path
        d="M53.8992 62.04C56.7508 59.4259 61.2975 59.0753 64.6882 60.9238C68.0789 62.7724 70.2214 66.5571 70.4539 70.4336C63.9834 71.0088 57.6426 70.8658 51.2253 69.8516C50.9542 69.8084 50.6517 69.7466 50.489 69.5225C50.3571 69.3389 50.3531 69.0967 50.366 68.8711C50.4476 67.4553 51.0108 66.1085 51.7136 64.8789C52.309 63.8368 53.0163 62.8492 53.8992 62.04ZM60.9001 46.6875C64.4888 46.6875 66.5016 50.4531 66.5017 54.0752C66.1283 57.1659 63.8168 59.6541 60.2283 59.6543C57.0166 59.6543 53.655 57.6974 53.655 54.0752C53.6551 47.3661 57.3114 46.6875 60.9001 46.6875Z"
        fill="white"
      />
      <path
        d="M58.8791 55.1242C58.0756 54.2508 56.7124 52.9038 56.2832 54.1884C55.8455 55.4984 56.5871 56.0598 57.0249 56.0598C57.8541 56.0598 58.8791 54.1883 60.7333 53.2525C62.5875 52.3168 64.4417 52.5039 64.2563 54.0011C64.0709 55.4983 62.5875 55.4984 61.6604 55.4984C60.7333 55.4984 59.8062 52.3776 59.8062 51.194C59.8062 50.0709 59.2499 49.1353 58.3228 49.5096C57.3957 49.8839 56.2832 52.1296 57.7666 52.5039C59.2499 52.8782 60.8475 50.5209 61.6604 50.0709C62.1498 49.8001 63.2623 49.6129 62.9583 51.194C62.6531 52.7818 62.5875 56.0597 61.6604 56.434C60.7333 56.8083 59.8833 56.0599 58.8791 55.1242Z"
        stroke={iconColorFill}
        strokeWidth="0.808335"
      />
    </g>
  );
}
